import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/lib/authContext';
import { useTranslation } from '@/lib/i18n';

export default function PortalGuard() {
    const { session, profile, profileError, loading, profileLoading } = useAuth();
    const { t } = useTranslation();

    if (loading) {
        return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
    }

    if (!session) {
        return <Navigate to="/portal/login" replace />;
    }

    if (profileLoading && !profile) {
        return <div className="min-h-screen flex items-center justify-center">Loading profile...</div>;
    }

    if (profileError && !profile) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-slate-50">
                <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full text-center border border-red-100">
                    <h2 className="text-xl font-bold text-slate-900 mb-2">{t('error.connection_title')}</h2>
                    <p className="text-slate-600 mb-6">{t('error.profile_load_fail')}</p>
                    <button
                        onClick={() => window.location.reload()}
                        className="w-full py-3 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition-all"
                    >
                        {t('report.retry')}
                    </button>
                </div>
            </div>
        );
    }

    if (!profile && !profileError) {
        return <div className="min-h-screen flex items-center justify-center">Loading profile...</div>;
    }

    // AUTHORITY_USER ONLY — admins get redirected to admin dashboard
    if (profile?.role !== 'AUTHORITY_USER') {
        if (profile?.role === 'ADMIN') {
            return <Navigate to="/admin/dashboard" replace />;
        }
        return <Navigate to="/portal/login" replace />;
    }

    if (profile?.is_active === false) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
}
